import styled, { css } from 'styled-components';

interface ContainerProps {
  $narrow?: boolean;
  $size?: 'small' | 'medium' | 'large';
  $bleedMobile?: boolean;
}

export const Container = styled.div.withConfig({ componentId: 'sc-19lriw1-0' })<ContainerProps>`
    width: 100%;
    max-width: ${(props) => props.theme.size.containerMaxWidth};
    margin-left: auto;
    margin-right: auto;
    padding: 0 ${(props) => props.theme.size.containerGutter};
    padding-left: max(env(safe-area-inset-left), ${(props) => props.theme.size.containerGutter});
    padding-right: max(env(safe-area-inset-right), ${(props) => props.theme.size.containerGutter});

    ${(props) => props.theme.breakpoint.LtMd} {
        padding: 0 ${(props) => props.theme.size.containerGutterLtMd};
    }

    ${({ $size }) =>
      $size === 'medium' &&
      css`
            max-width: 920px;
        `}

    ${({ $size }) =>
      $size === 'small' &&
      css`
            max-width: 728px;
        `}

    ${({ $bleedMobile }) =>
      $bleedMobile &&
      css`
            ${(props) => props.theme.breakpoint.LtMd} {
                padding-left: 0;
                padding-right: 0;
            }
        `}
`;
